import axios from 'axios'

export default () => {
  let parms = {
    baseURL: process.env.VUE_APP_API_DOSATRON_V1,
    withCredentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    }
  }

  if (localStorage.getItem('accept_language')) {
    parms.headers['Accept-Language'] = localStorage.getItem('accept_language')
  }

  return axios.create(parms)
}
